import { createIcon } from '@chakra-ui/react';

export const DisplayStatsIcon = createIcon({
  displayName: 'DisplayStatsIcon',
  viewBox: '0 0 48 48',
  defaultProps: {
    fill: 'none',
    height: '48',
    width: '48',
  },
  path: (
    <>
      <circle cx="24" cy="24.7754" r="24" fill="#F0F4F8" />
      <path
        d="M18 33.7754H30M34 28.7754V18.7754C34 17.6708 33.1046 16.7754 32 16.7754L16 16.7754C14.8954 16.7754 14 17.6708 14 18.7754L14 28.7754C14 29.88 14.8954 30.7754 16 30.7754L32 30.7754C33.1046 30.7754 34 29.88 34 28.7754Z"
        stroke="#0F5291"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </>
  ),
});
